var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoListo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23428",
    "data-name": "Grupo 23428",
    transform: "translate(-431 -776.92)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1756",
    "data-name": "Elipse 1756",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(431 776.92)",
    fill: "#e3f1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66164",
    "data-name": "Trazado 66164",
    d: "M120.091,203.154a.916.916,0,0,1-.648-.268l-3-3a.917.917,0,0,1,1.3-1.3l2.353,2.353,5.356-5.357a.917.917,0,0,1,1.3,1.3l-6,6.005A.914.914,0,0,1,120.091,203.154Z",
    transform: "translate(319.402 588.072)",
    fill: "#76bc21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoListo);
export default __webpack_public_path__ + "static/media/Icono-Listo.73a7aa7cf7f211cbee4319c4fdc71575.svg";
export { ForwardRef as ReactComponent };